module.exports = __webpack_public_path__ + "img/pagcor.c3f03997.png";